type ArticleNumberToVariationIdResponse = {
    variationId: string;
};

export class ArticleApi {
    public static async getVariationId(articleNumber: string): Promise<string> {
        const res = await fetch(`/article-variation/variation?articleNumber=${articleNumber}`, {
            method: 'GET',
            headers: {
                'x-requested-with': 'XMLHttpRequest',
            },
        });

        if (res.status !== 200) {
            throw new Error(
                `Could not find any variation id for the given article number: articleNumber: ${articleNumber}, status: ${res.status}`
            );
        }

        const variationResponse = (await res.json()) as ArticleNumberToVariationIdResponse;
        return variationResponse.variationId;
    }
}
